define('models/current-user',['require','models/base/model','underscore'],function(require) {
    'use strict';

    var Model = require('models/base/model'),
        _ = require('underscore');


    var CurrentUser = Model.extend({
        urlPath: '/api/session',

        defaults: {
            phoneNumber: '+7'
        },

        setDemo: function() {
            this.set({
                phoneNumber: '70000000000',
                password: '70000000000'
            });
        },

        isClientSB: function() {
            return this.hasRoles('new');
        },

        hasRoles: function(role){
            var roles = [].concat(role);
            var items = _.intersection(this.get('role'), roles);
            return items.length && items;
        }
    });

    return CurrentUser;
});
